<template>
  <div class="app-detail">
    <div v-if="pcStatus==0||pcStatus==1">
      <div class="page">
        <img class="bg" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220507/1b89087635e901fc44cc950610ea04fd.png">
        <div class="c1">
          <img class="c1-b h224" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220509/fab920a70b7b4c72efbf842d35604987.png" />
          <img class="c1-s" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220507/5f5817d793fccf68dc7918d37b1c48b7.png" />
          <div class="p">千万用户在用的签到打卡小程序，为群和公众号提供签到打卡服务。如果你是签到发起人，可以通过认证额外获得更多使用权益。</div>
        </div>
        <img class="c4" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220507/198bfaca2f0e680e3d2614362b60d53d.png" />
        <img class="c2" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20250220/019df0e6f09c99a934116c3c3732b7bd.png" />
        <img class="c3" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-11-22/82bb773330dc05598b03427634e4db70.png" />
        <div @click="showServiceDialog" class="contact">如有疑问，请<span style="color:#ffcc00">点击联系客服</span></div>
        <div class="foot">
          <div @click="toOther" class="btn-box">
            <button>立即认证</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="page" v-if="info!=null">
        <img class="bg" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220507/1b89087635e901fc44cc950610ea04fd.png">
        <div class="c1" v-if="is_certed==1">
          <img v-if="info.auth_type==0" class="certed-img" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220509/d9140c1168d9ca9a8639ba6a1dd7196d.png">
          <img v-if="info.auth_type==1" class="certed-img" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220509/94d6d093a824555fdcef53c20f85eb7c.png">
          <img v-if="info.auth_type==2" class="certed-img" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220509/a812ad962bfa051626bffb7f2209d333.png">
          <img class="c1-s" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220507/5f5817d793fccf68dc7918d37b1c48b7.png">
          <div class="p">
            <div>认证有效期:{{info.t_start|dateFormat}}至{{info.t_end|dateFormat}}</div>
            <div @click="showServiceDialog">如有疑问请点击<span style="color:#ffcc00">联系客服</span></div>
          </div>
        </div>
        <div class="c1" v-else-if="is_certed==0&&info.audit_status==2&&info.has_payed==1">
          <img class="c1-b h224" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220510/809d32b2f308a4b565a111bef3d62440.png" />
          <img class="c1-s" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220507/5f5817d793fccf68dc7918d37b1c48b7.png" />
          <div class="p">
            <div>失败原因：{{info.remark?info.remark:'资料信息存在不符，请重新核实后再申请'}}</div>
            <div @click="showServiceDialog">如有疑问请点击<span style="color:#ffcc00">联系客服</span></div>
          </div>
        </div>
        <div class="c1" v-else-if="info.auth_type==2&&(info.mp_code_status==1||info.mp_code_status==3||info.mp_code_status==0)&&info.has_payed==1">
          <img class="c1-b h346" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220509/d112b8670b800009e03c2776a072f852.png" />
          <img class="c1-s" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220507/5f5817d793fccf68dc7918d37b1c48b7.png" />
          <div class="p">
            <div>审核人员会在1个工作日内，在认证的公众号留言发送4位验证码。收到后请填写在下方，如有疑问请<span @click="showServiceDialog" style="color:#ffcc00">点击联系客服</span></div>
            <div class="code-box">
              <input placeholder="请输入验证码" class="code-input" v-model="code" type="text" />
              <div @click="sendcode" class="send-btn">确定</div>
            </div>
          </div>
        </div>
        <div class="c1" v-else-if="is_certed==0&&info.audit_status==0&&info.has_payed==1">
          <img class="c1-b h224" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220510/793c5c05c27216a55313f07e574772db.png" />
          <img class="c1-s" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220507/5f5817d793fccf68dc7918d37b1c48b7.png" />
          <div class="p">提交成功！系统审核中，预计将在1个工作日内完成审核，如有疑问请<span @click="showServiceDialog" style="color:#ffcc00">点击联系客服</span></div>
        </div>
        <div class="c1" v-else-if="is_certed==0||is_certed==2">
          <img class="c1-b h224" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220509/fab920a70b7b4c72efbf842d35604987.png" />
          <img class="c1-s" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220507/5f5817d793fccf68dc7918d37b1c48b7.png" />
          <div class="p">千万用户在用的签到打卡小程序，为群和公众号提供签到打卡服务。如果你是签到发起人，可以通过认证额外获得更多使用权益。</div>
        </div>
        <img class="c4" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220507/198bfaca2f0e680e3d2614362b60d53d.png" />
        <img class="c2" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20250220/019df0e6f09c99a934116c3c3732b7bd.png" />
        <img class="c3" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2022-11-22/82bb773330dc05598b03427634e4db70.png" />
        <div @click="showServiceDialog" class="contact">如有疑问，请<span style="color:#ffcc00">点击联系客服</span></div>
        <div class="foot">
          <div class="btn-box">
            <button v-if="is_certed==1" @click="toInputInfo(2)">续费</button>
            <button v-else-if="is_certed==0&&info.audit_status==0&&info.has_payed==1" @click="showWait">等待审核</button>
            <button v-else-if="is_certed==0&&info.audit_status==2&&info.has_payed==1" @click="toChooseMode">修改资料</button>
            <button v-else-if="is_certed==0||is_certed==2" @click="toChooseMode">立即认证</button>
          </div>
        </div>
      </div>
      <div class="dialog" v-show="showQr">
        <div class="mask" @click="showQr = false"></div>
        <div class="dialog-body" @click.stop="nothing">
          <div class="content">
            <img class="bg" src="https://cdn-xcxcustom.weiyoubot.cn/20210826/4775e8a38a1114a330492296b7fa9a6b.png">
            <div class="no-bg">
              <div class="title" v-if="is_certed==1">您已认证成功</div>
              <div class="title" v-else-if="info.has_payed==1">认证资料已提交</div>
              <div class="p1">现为您提供<span>专属客服服务</span></div>
              <div class="p2">长按下方二维码即可添加</div>
              <img class="qr" @click.stop="showQrUrl" :src="qr">
              <button @click.stop="showQr = false">我知道啦</button>
            </div>
          </div>
        </div>
      </div>

      <div class="dialog" v-show="show_service">
        <div class="mask" @click="show_service = false"></div>
        <div class="dialog-body" @click.stop="nothing">
          <div class="content">
            <img class="bg" src="https://cdn-xcxcustom.weiyoubot.cn/20210826/4775e8a38a1114a330492296b7fa9a6b.png">
            <div class="no-bg">
              <div class="p2">长按下方二维码即可添加专属客服</div>
              <img class="qr"  @click.stop="showQrUrl" :src="qr">
              <button @click.stop="show_service = false">我知道啦</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog" v-show="show_service">
      <div class="mask" @click="show_service = false"></div>
      <div class="dialog-body" @click.stop="nothing">
        <div class="content">
          <img class="bg" src="https://cdn-xcxcustom.weiyoubot.cn/20210826/4775e8a38a1114a330492296b7fa9a6b.png">
          <div class="no-bg">
            <div class="p2">长按下方二维码即可添加专属客服</div>
            <img class="qr" @click.stop="showQrUrl" :src="qr">
            <button @click.stop="show_service = false">我知道啦</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/utils/request';
import { getToken, jumpWxAuth, getPc } from '@/utils/common'
import { Toast } from 'vant'
export default {
  data() {
    return {
      schemeUrl: '',
      pcStatus: getPc(),
      code: '',
      show_service: false,
      info: null,
      is_certed: 0,
      showQr: false,
      qr: 'https://cdn-xcxcustom.weiyoubot.cn/20210702/4016eef50040e00f919677e68def96d6.png'
    }
  },
  mounted() {
    if (this.pcStatus == 0) {
      location.replace('http://www.xiaoqiandao.com/cerficate?from=h5')
      return;
    }
    if (this.pcStatus == 1) {
      this.getSchemeUrl()
      return;
    }
    // 微信+mobile环境
    // if (this.$route.query.showqr == 1) this.showQr = true
    if (!getToken()) {
      jumpWxAuth()
    } else {
      this.getInfo()
    }
  },
  components: {
    [Toast.name]: Toast,
  },
  methods: {
    toOther() {
      if (this.schemeUrl) {
        window.location.href = this.schemeUrl
        return;
      } else {
        window.open('http://www.xiaoqiandao.com/home')
      }
    },
    showServiceDialog() {
      window.open('https://work.weixin.qq.com/kfid/kfc45a7bbd4d1d50814?enc_scene=ENCKfL1wB84RBUrH13h3Ur95avpzfbHQyWxWD8NqoEmVyWmiTnqSBBNmFrzjevnBniRh')
      // this.show_service = true
    },
    showQrUrl() {
      let qr = this.qr
      wx.previewImage({
        current: qr,
        urls: [qr]
      })
    },
    nothing() {
      console.log('no')
    },
    showWait() {
      Toast('请耐心等待1个工作日内的审核')
    },
    sendcode() {
      if (this.code == '') {
        Toast('请输入验证码')
        return
      }
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      let param = {
        access_token: getToken(),
        cert_id: this.info.cert_id,
        mp_verify_code: this.code
      }
      http.post('/xcx/checkin_web/v1/cert/mp/verify', param).then(res => {
        let { sta, msg } = res
        if (sta == -1) {
          Toast(msg)
        } else {
          setTimeout(() => {
            this.getInfo()
          }, 1000)
        }
      })
    },
    getSchemeUrl() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      let param = {
        source: "h5",
        biz: 'cert'
      };
      http.get('/xcx/checkin/v1/scheme', param).then(res => {
        Toast.clear();
        let { data, sta } = res
        if (sta == 0) {
          this.schemeUrl = data.url
        }
      }).catch(err => {
        Toast.clear();
      });
    },
    getInfo() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      let param = {
        source: "h5",
        access_token: getToken(),
        random: Math.random()
      };
      http.get('/xcx/checkin_web/v1/cert/detail', param).then(res => {
        Toast.clear();
        let { data, is_certed, price_list, sta, can_cert } = res
        if (sta == 0) {
          this.is_certed = is_certed;
          this.can_cert = can_cert * 1
          // 存下所有数据
          if (data.cert_pic_back) {
            data.cert_pic_back = [{ url: data.cert_pic_back }]
            data.cert_pic_front = [{ url: data.cert_pic_front }]
          }
          if (data.corp_liscense_pic) {
            data.corp_liscense_pic = [{ url: data.corp_liscense_pic }]
          } else {
            data.corp_liscense_pic = []
          }
          if (data.mp_screen) {
            data.mp_screen = [{ url: data.mp_screen }]
          } else {
            data.mp_screen = []
          }
          localStorage.setItem('info', JSON.stringify(data))
          localStorage.setItem('price_list', JSON.stringify(price_list))
          localStorage.setItem('is_certed', is_certed)
          this.info = data;
        }
      }).catch(err => {
        Toast.clear();
      });
    },
    toChooseMode() {
      if (this.info.auth_type == 0 && this.info.audit_status == 2) {
        this.$router.push({ name: 'inputInfo', query: { type: 0 } },)
      } else if (this.info.auth_type == 1 && this.info.audit_status == 2) {
        this.$router.push({ name: 'inputInfo', query: { type: 1 } },)
      } else if (this.info.auth_type == 2 && this.info.audit_status == 2) {
        this.$router.push({ name: 'inputInfo', query: { type: 2 } },)
      } else {
        this.$router.push({ name: 'chooseMode' })
      }
    },
    toInputInfo(type) {
      if (this.info.auth_type == 0) {
        this.$router.push({ name: 'inputInfo', query: { type: 0, xufei: 1 } },)
      } else if (this.info.auth_type == 1) {
        this.$router.push({ name: 'inputInfo', query: { type: 1, xufei: 1 } },)
      } else if (this.info.auth_type == 2) {
        this.$router.push({ name: 'inputInfo', query: { type: 2, xufei: 1 } },)
      }
    }
  }
}

</script>



<style scoped lang="scss">
@function rem($px) {
  @return $px / 75 + rem;
}

.page {
  padding-bottom: rem(200);
  background-color: #000;
  position: relative;
  .qr-btn {
    position: absolute;
    top: rem(20);
    left: rem(20);
    font-size: rem(24);
    color: #fff;
    display: flex;
    align-items: center;
    z-index: 999;
    img {
      width: rem(40);
      height: rem(40);
      margin-right: rem(20);
    }
    div {
      height: rem(40);
      line-height: rem(40);
    }
  }
}
.bg {
  position: absolute;
  top: 0;
  width: 100%;
  height: rem(452);
}

.c1 {
  margin: auto;
  padding-top: rem(100);
  width: rem(690);
  position: relative;
  margin-bottom: rem(20);
  z-index: 1;
}

.c1-b {
  vertical-align: top;
  width: rem(690);
  height: rem(260);
}

.c1-s {
  position: absolute;
  width: rem(400);
  height: rem(270);
  top: rem(-10);
  right: 0;
}

.c1 .p {
  position: absolute;
  width: rem(610);
  color: #262626;
  line-height: 1.5;
  font-size: rem(24);
  top: rem(200);
  left: rem(40);
}

.c2 {
  display: block;
  margin: auto;
  width: rem(690);
  height: rem(2344);
  margin-bottom: rem(20);
}

.c4 {
  position: relative;
  left: rem(30);
  width: rem(690);
  height: rem(240);
  margin-bottom: rem(20);
  z-index: 10;
}

.c3 {
  display: block;
  margin: auto;
  width: rem(690);
  height: rem(388);
}

.foot {
  background-color: #000;
  width: rem(750);
}

.foot button {
  background: #d8ae7a;
  color: #262626;
}
.h200 {
  height: rem(200);
}
.h230 {
  height: rem(230);
}
.h260 {
  height: rem(260);
}
.h224 {
  height: rem(224);
}
.h346 {
  height: rem(346);
}
.to-ads {
  padding: rem(34);
  color: #fff;
}

.dialog,
.mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 10;
}
.dialog-body {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  z-index: 1001;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
  .content {
    position: relative;
    width: rem(660);
    height: rem(980);
    .bg,
    .no-bg {
      top: 0;
      left: 0;
      position: absolute;
      width: rem(660);
      height: rem(980);
    }
    .no-bg {
      height: rem(700);
      padding-top: rem(280);
      z-index: 1;
      display: flex;
      align-items: center;
      flex-direction: column;
      .title {
        color: #12b7f5;
        font-size: rem(40);
        font-weight: bold;
        margin-bottom: rem(20);
      }
      .qr {
        z-index: 1;
        width: rem(350);
        height: rem(350);
        margin: rem(30) 0;
      }
      .p1 {
        margin-top: rem(10);
        font-size: rem(30);
        color: #666;
        span {
          color: #dbac57;
        }
      }
      .p2 {
        font-size: rem(32);
        color: #666;
      }
      button {
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        width: 90%;
        height: rem(80);
        background-color: #12b7f5;
        border-radius: rem(10);
        font-size: rem(32);
        line-height: 60px;
      }
    }
  }
}

.certed-img {
  width: rem(690);
  height: rem(224);
}
.contact {
  text-align: center;
  padding: rem(20) rem(0);
  font-size: rem(28);
  color: #999;
}
.code-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: rem(20);
}
.code-input {
  width: rem(514);
  height: rem(60);
  border-radius: rem(8);
  border: 1px solid #eeeeee;
  font-size: rem(28);
  color: #262626;
}
.send-btn {
  margin-left: rem(20);
  width: rem(96);
  height: rem(60);
  border-radius: rem(8);
  background-color: #ffcc00;
  color: #fff;
  font-size: rem(28);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/cert/certStatus.vue